import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import z from "zod";

const FormSchema = z.object({
  firstname: z.string().min(1, "First Name is required."),
  lastname: z.string().optional(),
  email: z.email("Invalid email address."),
  phone: z.string().min(1, "Phone Number is required."),
  street_address: z.string().min(1, "Street Address is required."),
  city: z.string().min(1, "City is required."),
  state: z.string().min(1, "State is required."),
  postal_code: z.string().min(1, "Postal Code is required."),
});

type FormValues = z.infer<typeof FormSchema>;

const defaultValues: FormValues = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  street_address: "",
  city: "",
  state: "",
  postal_code: "",
};

type Props = {
  onBack: () => void;
  onSubmit: (data: any) => void;
};

export const RecipientForm = ({ onBack, onSubmit }: Props) => {
  const { control, handleSubmit } = useForm<FormValues>({
    resolver: zodResolver(FormSchema),
    defaultValues,
  });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xs={12} md={6}>
            <Controller
              name="firstname"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    First Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="lastname"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    {...field}
                    isInvalid={!!fieldState.error}
                  />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="phone"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Phone Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="street_address"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Street Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="city"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    City <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>

          <Col xs={12} md={6}>
            <Controller
              name="state"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    State <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>

          <Col xs={12} md={6}>
            <Controller
              name="postal_code"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Postal Code <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
        </Row>
        <div className="d-flex justify-content-between gap-3 mt-3">
          <Button
            type="button"
            variant="light"
            onClick={onBack}
            className="px-4"
          >
            Back
          </Button>
          <Button type="submit" className="px-4">
            Next
          </Button>
        </div>
      </form>
    </>
  );
};
